import get from 'lodash/get';
import set from 'lodash/set';

import { contractUtils } from 'lib/contract';

/**
 * Sort array of components to display based on context set by user
 *
 * @param {object} p - function params
 * @param {object[]} p.components - array of components to be filtered
 * @param {string} p.field - content context field to filter
 * @param {string[]} p.filterValues - values that should be kept after filtering
 * @param {Function} p.getContract - function to get contract based on schema name
 * @returns {{hide: string[], keep: object[]}} object with strings to hide and objects to keep
 */
export const contentContextFilter = ({
  components = [],
  field,
  filterValues,
  getContract
}) => {
  const hide = [];
  const keep = components.filter(component => {
    // component only has SchemaName info because it's based on capi response
    const { SchemaName: schemaName } = component;
    const contract = getContract(schemaName);
    const [childLocation] = contractUtils.getPropLocation(contract, 'AttachChildInput');

    // recurse when there are more components to filter
    if (childLocation) {
      // remove 'Payload.' prefix
      const loc = childLocation.replace('Payload.', '');
      const data = contentContextFilter({
        components: get(component, loc),
        field,
        filterValues,
        getContract
      });
      set(component, loc, data.keep);
      hide.push(...data.hide);
    }

    // include component when content context is missing
    const contentContext = component?.MetadataFields?.ContentContext;
    if (!contentContext) {
      return true;
    }

    const fieldData = Array.isArray(contentContext)
      ? contentContext.find(obj => obj[field])?.[field]
      : contentContext[field];
    if (!fieldData) {
      return true;
    }

    // only apply filtering when both component payload and given preview request have data
    if (fieldData.length && filterValues.length) {
      const hasMatch = fieldData.some(option => filterValues.includes(option));
      if (!hasMatch) {
        hide.push(component.Id);
      }
      return hasMatch;
    }
    return true;
  });
  return { hide, keep };
};
